<template>
    <v-dialog v-model="projectApproveDialog" width="400">
        <v-card component="ProjectApproveDialog">
            <btn class="close" size="icon" color="transparent" :icon="'close'" @click="close" />

            <v-form v-model="valid" ref="form" @submit.prevent="">
                <div class="header" v-if="projectWasSent">
                    <p>
                        This project was sent for approval<br />
                        to email <a :href="`mailto:${project.schvalenie_email}`">{{ project.schvalenie_email }}</a
                        ><br />
                        by <a :href="`mailto:${project.odoslal}`">{{ project.odoslal }}</a
                        ><br />
                        on {{ getDateWithTime(project.schvalenie_odoslane) }}
                    </p>
                </div>

                <div class="header" v-else>
                    <p>
                        This project was never sent for approval!<br />
                        <b>Are you sure to approve now?</b>
                    </p>
                </div>

                <div class="action">
                    <div class="buttons">
                        <btn color="transparent" :text="'Cancel'" @click="close" />
                        <div class="holder" :class="{ confirm: confirm }">
                            <btn
                                class="send"
                                :icon="'send'"
                                :text="'Approve'"
                                tpos="left"
                                :color="'accent'"
                                @click.prevent="tryApprove"
                            />
                            <btn
                                class="confirm"
                                :icon="'check'"
                                :text="'Confirm'"
                                tpos="left"
                                :color="'base'"
                                :state="loading"
                                @click.prevent="approve"
                            />
                        </div>
                    </div>
                    <div class="message" :class="{ done: result !== null, wrong: result === false }">
                        <i class="icon" v-if="result">done_all</i>
                        <i class="icon" v-else>warning</i>
                        <h3>{{ message }}</h3>
                    </div>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

export default {
    name: 'ProjectApproveDialog',

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    created() {
        if (!this.projectWasSent) this.confirm = true;
    },

    data() {
        return {
            loading: '',
            confirm: false,
            message: '',
            result: null,
            valid: true,
        };
    },

    methods: {
        ...mapActions(['approveProject']),
        ...mapMutations(['setProjectApproveDialog']),

        getDateWithTime(date) {
            return `${moment(date).format('DD. MM. YYYY')} at ${moment(date).format('HH:mm')}`;
        },

        reset() {
            this.loading = '';
            this.confirm = false;
            this.message = '';
            this.result = null;
        },

        close() {
            this.setProjectApproveDialog(false);
            this.reset();
        },

        tryApprove() {
            this.confirm = true;
        },

        async approve() {
            this.loading = 'load';
            await this.approveProject({
                id: this.project.id,
            }).then((result) => {
                this.result = result;
            });

            this.loading = '';
            this.confirm = false;
            this.message = this.result ? 'Project was approved' : 'Something went wrong';

            setTimeout(() => {
                if (!this.result) {
                    this.result = null;
                    return;
                }

                this.setProjectApproveDialog(false);
                this.reset();
            }, 2000);
        },
    },

    computed: {
        ...mapGetters(['getProjectApproveDialog', 'projectWasSent']),

        projectApproveDialog: {
            get: function () {
                return this.getProjectApproveDialog;
            },
            set: function (val) {
                this.setProjectApproveDialog(val);
            },
        },
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectApproveDialog'] {
    padding: 20px;

    .close {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
    }

    form {
        display: flex;
        flex-direction: column;
    }

    .header {
        margin-bottom: 25px;

        p {
            margin: 0 30px 15px 0;
        }
    }

    .action {
        position: relative;
        overflow: hidden;
        width: 100%;
        .flex-row;
        justify-content: flex-end;

        .buttons {
            .flex-row;
        }

        .holder {
            position: relative;

            &.confirm {
                .send {
                    transform: translateY(100%);
                }

                .confirm {
                    transition-delay: 0.3s;
                    transform: translateY(0);
                }
            }

            button {
                transition: 0.3s;

                &.confirm {
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 4;
                    transform: translateY(100%);
                    transition-delay: 0.3s;
                }
            }
        }
    }

    .message {
        position: absolute;
        background: white;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        color: @base;
        transition: 0.3s;
        transition-delay: 0.3s;
        transform: translateY(100%);

        &.wrong {
            color: @accent;

            h3 {
                color: @accent;
            }
        }

        &.done {
            transition-delay: 0s;
            transform: translateY(0);
        }

        h3 {
            color: @base;
            margin: 0 0 0 5px;
        }
    }
}
</style>
